import { render, staticRenderFns } from "./SelectBranch.vue?vue&type=template&id=384a2930&scoped=true&"
import script from "./SelectBranch.vue?vue&type=script&lang=js&"
export * from "./SelectBranch.vue?vue&type=script&lang=js&"
import style0 from "./SelectBranch.vue?vue&type=style&index=0&id=384a2930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a2930",
  null
  
)

export default component.exports